<template>
  <div>
    <vs-card>
      <ag-grid-vue style="width: 100%; height: 450px; margin-top: 25px" class="ag-theme-alpine"
        :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="rowData" :rowSelection="rowSelection"
        :localeText="localeText" @grid-ready="onGridReady" @cell-value-changed="onCellValueChanged"
        :suppressRowClickSelection="true" :pagination="true">
      </ag-grid-vue>
    </vs-card>
    <vs-popup type="filled" pazaryer title="Kategoriler" :active.sync="popupCategory" >
      <StockCategoryTree :treeData="treeData" :findedCategories="findedCategories" :stock="stock" />
    </vs-popup>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import FirmaTanimliAlanlarStockView from "./CellRenderers/FirmaTanimliAlanlarStockView.vue"
import FirmaTanimliAlanlarStockCheckbox from "./CellRenderers/FirmaTanimliAlanlarStockCheckbox.vue"
import StockCategoryTree from "./Components/StockCategoryTree.vue"
import FirmaTanimliAlanlarButtons from "./Components/FirmaTanimliAlanlarButtons.vue"
export default {
  components: {
    StockCategoryTree,
    AgGridVue,
    FirmaTanimliAlanlarStockView,
    FirmaTanimliAlanlarStockCheckbox,
    FirmaTanimliAlanlarButtons
  },
  data() {
    return {
      stock: "",
      findedCategories: [],
      treeData: [],
      popupCategory: false,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      rowSelection: null,
      rowData: null,
      localeText: null,
      columnDefs: null,
      ozelCode9: [],
      groupCode: [],
      unitList: [],
      gType: [],
      categories: [],
      subCategories: [],
      mark: [],
      arac: []
    };
  },
  methods: {
 
    onCellValueChanged(params) {
      const colId = params.column.getId();
      var vm = this;
      const vs = this.$vs;


      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        STOCKID: params.data.STOCKID,
        PARAM: colId,
        VALUE: colId == "GTYPEID" ? params.data.GTYPEID : colId == "UNITID" ? params.data.UNITID : params.newValue
      }
      soap.createClient(url, function (err, client) {
        client.INT_Upt_StokFirmaTanimliAlanlar(args, function (err, result) {
          if (result.INT_Upt_StokFirmaTanimliAlanlarResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let jsonData = JSON.parse(result.INT_Upt_StokFirmaTanimliAlanlarResult)
            if (jsonData.response == "Ok")
              vs.notify({
                title: "Güncellendi",
                text: colId + " alanı güncellendi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
          } catch (error) {
            console.log(error)
          }

        });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.getStockList();
    },
    getStockList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      }
      soap.createClient(url, function (err, client) {
        client.INT_Ls_StokFirmaTanimliAlanlar(args, function (err, result) {
          if (result.INT_Ls_StokFirmaTanimliAlanlarResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let jsonData = JSON.parse(result.INT_Ls_StokFirmaTanimliAlanlarResult).jsonData
            vm.rowData = JSON.parse(jsonData)
          } catch (error) {
            console.log(error)
          }

        });
      });

    },
   

    getCategoriesAllList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      }
      soap.createClient(url, function (err, client) {
        client.INT_Ls_StokCategories(args, function (err, result) {
          if (result.INT_Ls_StokCategoriesResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let jsonData = JSON.parse(result.INT_Ls_StokCategoriesResult).jsonData
            vm.treeData = JSON.parse(jsonData); 
          } catch (error) {
            console.log(error)
          }

        });
      });

    },
    getUnitList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      }
      soap.createClient(url, function (err, client) {
        client.INT_Ls_StockUnit(args, function (err, result) {
          if (result.INT_Ls_StockUnitResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let jsonData = JSON.parse(result.INT_Ls_StockUnitResult).jsonData
            vm.unitList = JSON.parse(jsonData)
          } catch (error) {
            console.log(error)
          }

        });
      });

    },
    getCategories(mainCategory) { 
      var vm = this;
      vm.categories = []
      vm.subCategories = []
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        mainCategory: mainCategory
      }
      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_Kategori(args, function (err, result) {
          if (result.INT_Ls_Stock_KategoriResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let jsonData = JSON.parse(result.INT_Ls_Stock_KategoriResult).jsonData
            vm.categories = jsonData.categories
            vm.subCategories = jsonData.altcategories
          } catch (error) {
            console.log(error)
          }

        });
      });
    },
    getGTYPE() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      }
      soap.createClient(url, function (err, client) {
        client.INT_Ls_StockGTYPE(args, function (err, result) {
          if (result.INT_Ls_StockGTYPEResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let jsonData = JSON.parse(result.INT_Ls_StockGTYPEResult).jsonData
            vm.gType = JSON.parse(jsonData)
          } catch (error) {
            console.log(error)
          }

        });
      });

    },
    getGlobalDefinitions(mainParam, root) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        mainParameter: mainParam,
        root: root
      }
      soap.createClient(url, function (err, client) {
        client.INT_Ls_StockGlobalSpec(args, function (err, result) {
          if (result.INT_Ls_StockGlobalSpecResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let jsonData = JSON.parse(result.INT_Ls_StockGlobalSpecResult).jsonData
            if (root == "SPECCODE9") {
              vm.ozelCode9 = JSON.parse(jsonData)

            }
            else if (root == "GROUPCODE") {
              vm.groupCode = JSON.parse(jsonData)

            }
            else if (root == "SPECCODE_MARKAU") {
              vm.mark = JSON.parse(jsonData)
            }
            else if (root == "SPECCODE_ARACU") {
              vm.arac = JSON.parse(jsonData)
            }
          } catch (error) {
            console.log(error)
          }

        });
      });

    },
    pickCategory(data) {
      this.popupCategory = true
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      vm.stock = data.data.STOCKID
      const args = {
        token: Store.state.tokenId,
        STOCKID: data.data.STOCKID
      }
      soap.createClient(url, function (err, client) {
        client.INT_Ls_StokCategories(args, function (err, result) {
          if (result.INT_Ls_StokCategoriesResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let jsonData = JSON.parse(result.INT_Ls_StokCategoriesResult).jsonData
            const selectedCategoryIds = JSON.parse(jsonData)
            vm.findedCategories = selectedCategoryIds.map(item => item.CATEGORYID);
          } catch (error) {
            console.log(error)
          }

        });
      });

    }
  },

  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";

    this.getUnitList()
    this.getGTYPE();
    this.getGlobalDefinitions("VE_STOCK", "SPECCODE9")
    this.getGlobalDefinitions("VE_STOCK", "GROUPCODE")
    this.getCategories();

    this.getGlobalDefinitions("", "SPECCODE_MARKAU")
    this.getGlobalDefinitions("", "SPECCODE_ARACU")
    this.getCategoriesAllList()

  },
  mounted() {
    this.$root.$on("categoryPick", (data) => {
      this.pickCategory(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("categoryPick");
  },
  beforeMount() {
    this.columnDefs = [
      /*  {
          width: 250,
          field: "",
          cellRendererFramework: "FirmaTanimliAlanlarStockView",
        },*/
      {
        width: 50,
        field: "",
        cellRendererFramework: "FirmaTanimliAlanlarButtons",
      },
      {
        headerName: "Giriş Adedi",
        width: 50,
        field: "QENTRY",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
      },
      {
        headerName: "Çıkış Adedi",
        field: "QEXIT",
        width: 50,

        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
      },
      {
        headerName: "Depo",
        field: "QDEPOT",
        width: 50,

        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
      },
      {
        headerName: "Stok Kodu",
        field: "STOCKNO",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        width: 130,
      },
      {
        headerName: "Stok Adı",
        sortable: true,
        field: "STOCKNAME",
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Birim",
        field: "UNITID",
        sortable: true,
        width: 70,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: () => ({
          values: ["", ...this.unitList.map(unit => unit.UNITNAME)]

        }),
        onCellValueChanged: params => {
          const selectedUnit = this.unitList.find(unit => unit.UNITNAME === params.newValue);
          if (selectedUnit) {
            params.data.UNITID = selectedUnit.UNITID;
          }
        },
        valueFormatter: params => {
          if (!params.value) return "";
          const selectedUnit = this.unitList.find(unit => unit.UNITID === params.value);
          return selectedUnit ? selectedUnit.UNITNAME : params.value;
        },
      },

      {
        headerName: "Fiyat Listesi",
        field: "PRICELIST",
        sortable: true,
        width: 70,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        cellRendererFramework: "FirmaTanimliAlanlarStockCheckbox",
        onCellValueChanged: params => {
        }
      },
      {
        headerName: "Web Stok",
        field: "WEBSTOCK",
        width: 70,
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        cellRendererFramework: "FirmaTanimliAlanlarStockCheckbox",
        onCellValueChanged: params => {
        }
      },
      {
        headerName: "Özel Kod 9",
        field: "SPECCODE9",
        width: 120,
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: () => ({
          values: ["", ...this.ozelCode9.map(unit => unit.CODE)]

        }),
        onCellValueChanged: params => {
          const selectedozelCode9 = this.ozelCode9.find(ozelCode9 => ozelCode9.CODE === params.newValue);
          if (selectedozelCode9) {
            params.data.ozelCode9ID = selectedozelCode9.ozelCode9ID;
          }
        }
      },
      {
        headerName: "Tedarikçi Stok",
        field: "SUPPLIERSTOCKNO",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
      },
      {
        headerName: "GTIP",
        field: "GTYPEID",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",

        editable: true,
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: () => ({
          values: ["", ...this.gType.map(unit => unit.GTYPENO)]

        }),
        onCellValueChanged: params => {
          const selectedgType = this.gType.find(gType => gType.GTYPENO === params.newValue);
          if (selectedgType) {
            params.data.GTYPEID = selectedgType.GTYPEID;
          }
        },
        valueFormatter: (params) => {
          if (!params.value) return '';
          if (Array.isArray(params.value)) {
            return params.value
              .map(GTYPEID => {
                const gType = this.gType.find(cat => cat.GTYPEID === GTYPEID);
                return gType ? gType.GTYPENO : GTYPEID;
              })
              .join(', ');
          }
          const gType = this.gType.find(cat => cat.GTYPEID === params.value);
          return gType ? gType.GTYPENO : params.value;
        },
      },
      {
        headerName: "Kampanya Ürünler",
        field: "KAMPANYAURUNLER",
        sortable: true,
        width: 70,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        cellRendererFramework: "FirmaTanimliAlanlarStockCheckbox",
        onCellValueChanged: params => {
        }
      },
      {
        headerName: "Vitrin",
        field: "VITRINURUNLER",
        sortable: true,
        width: 70,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        cellRendererFramework: "FirmaTanimliAlanlarStockCheckbox",
        onCellValueChanged: params => {
        }
      },
      {
        headerName: "Kategori",
        field: "SPECCODE_KATEGORIU",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: () => ({
          values: ["", ...this.categories.map(unit => unit.CODE)]

        }),
        onCellValueChanged: params => {
          const selectedUnit = this.categories.find(unit => unit.CODE === params.newValue);
          this.getCategories(params.newValue)
          if (selectedUnit) {
            params.data.CODE = selectedUnit.CODE;
          }
        }
      },
      {
        headerName: "Alt Kategori",
        field: "SPECCODE_KATEGOR_ALTU",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: () => ({
          values: ["", ...this.subCategories.map(unit => unit.CODE)]
        }),
        onCellValueChanged: params => {
          const selectedUnit = this.subCategories.find(unit => unit.CODE === params.newValue);
          if (selectedUnit) {
            params.data.CODE = selectedUnit.CODE;
          }
        }
      },
      {
        headerName: "Grup Kodu",
        field: "GROUPCODE",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: () => ({
          values: ["", ...this.groupCode.map(unit => unit.CODE)]

        }),
        onCellValueChanged: params => {
          const selectedUnit = this.groupCode.find(unit => unit.CODE === params.newValue);
          if (selectedUnit) {
            params.data.CODE = selectedUnit.CODE;
          }
        }
      },
      {
        headerName: "Marka",
        field: "SPECCODE_MARKAU",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: () => ({
          values: ["", ...this.mark.map(unit => unit.CODE)]
        }),
        onCellValueChanged: params => {
          const selectedUnit = this.mark.find(unit => unit.CODE === params.newValue);
          if (selectedUnit) {
            params.data.CODE = selectedUnit.CODE;
          }
        }
      },
      {
        headerName: "Araç",
        field: "SPECCODE_ARACU",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: () => ({
          values: ["", ...this.arac.map(unit => unit.CODE)]
        }),
        onCellValueChanged: params => {
          const selectedUnit = this.arac.find(unit => unit.CODE === params.newValue);
          if (selectedUnit) {
            params.data.CODE = selectedUnit.CODE;
          }
        }
      },
      {
        headerName: "OEM Nolar",
        field: "OEMNOLAR",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,

      },
      {
        headerName: "Alternatif Nolar",
        field: "ALTERNATIFNOLAR",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,

      },
      {
        headerName: "Webde Olmayan Alt. Nolar",
        field: "WEBDEOLMAYANALTNO",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,

      },
      {
        headerName: "Ön Taraf Özellik",
        field: "ONTARAFOZELLIK",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,

      },
      {
        headerName: "Arka Taraf Özellik",
        field: "ARKATARAFOZELLIK",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,

      },
      {
        headerName: "Ölçü",
        field: "OLCU",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,

      },
      {
        headerName: "İngilizce",
        field: "DIL_ENG",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,

      },
      {
        headerName: "Fransızca",
        field: "DIL_FR",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,

      },
      {
        headerName: "Rusça",
        field: "DIL_RUS",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,

      },
      {
        headerName: "İspanyolca",
        field: "DIL_SPA",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,
      },
      {
        headerName: "Arapça",
        field: "DIL_ARP",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,
      },
      {
        headerName: "Almanca",
        field: "DIL_GER",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,
      },
      {
        headerName: "Portekizce",
        field: "DIL_POR",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,
      },
      {
        headerName: "Polonya",
        field: "DIL_POL",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,
      },
      {
        headerName: "Müşterinin İstediği Araç",
        field: "MUSTERININISTEDIGIARACADI",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
      },
      {
        headerName: "Müşterinin Kutu Adedi",
        field: "MUSTERININKUTUADETI",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agTextColumnFilter",
        editable: true,
      },
      {
        headerName: "Kayıt",
        field: "INSERTDATE",
        sortable: true,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        filter: "agNumberColumnFilter",
        editable: true,
      },
    ];
  },
}
</script>